import React from 'react';
import { Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import HistoricoPesquisaItem from './HistoricoPesquisaItem';
import { Store } from '../../../../store';
import { removeLog } from '../../../../store/ducks/pesquisa';

const HistoricoPesquisa = ({ logRx, closeModal }) => {
    const { t } = useTranslation();

    const blacklist = ['/novas_aquisicoes?for=TODOS'];

    const refazerPesquisa = () => closeModal();

    const removerItemLog = logId => Store.dispatch(removeLog(logId));

    return (
        <Row>
            <Col md="12" xs="12">
                {logRx.filter(i => !blacklist.includes(i.url)).length ? (
                    logRx
                        .slice()
                        .reverse()
                        .filter(i => !blacklist.includes(i.url))
                        .map((itemLog, index) => (
                            <HistoricoPesquisaItem
                                key={`log-${index}`}
                                item={itemLog}
                                indice={index}
                                t={t}
                                refazerPesquisa={refazerPesquisa}
                                removerItem={
                                    index === 0 ? false : removerItemLog
                                }
                            />
                        ))
                ) : (
                    <Row className="b-w1 b-cinza2 b-solid-top pad20">
                        <Col md="12" xs="12" className="text-center mt-2">
                            <h5 className="preto50">
                                {t('NenhumaPesquisaHistorico')}
                            </h5>
                        </Col>
                    </Row>
                )}
            </Col>
        </Row>
    );
};

const mapStateToProps = state => ({
    logRx: state.pesquisa.log,
});

export default connect(mapStateToProps)(HistoricoPesquisa);
